import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { CommentTypeReferenceModel } from "../../models/reference-model/reference-general-model";

@Injectable({
    providedIn: 'root'
})
export class CommentTypeReferenceService extends ApiServiceBase {
    private readonly PATH = "/system/CommentTypeReferences"

    constructor(httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getCommentTypeReferences(): Observable<CommentTypeReferenceModel[]> {
        return this.httpGet<CommentTypeReferenceModel[]>(this.PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
}